import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["id", "selectionType", "selectionCSS"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from "prop-types";
import React from "react";
import Checkbox from "../../Checkbox/Checkbox";
import RadioButton from "../../RadioButton/RadioButton";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

function SelectionControl(props) {
  const {
    id,
    // eslint-disable-line no-unused-vars
    selectionType,
    selectionCSS
  } = props,
        others = _objectWithoutProperties(props, _excluded);
  /**
   * Wraps a callback to withSelectable.jsx's `onChange` prop.
   */


  const handleSelection = _ref => {
    let {
      value,
      type
    } = _ref;
    const {
      onValueChange,
      checked
    } = props;

    if (type === "radio") {
      /**
       * For radio buttons, we use the value provided by the input because
       * React Hook Form will call the `handleChange` method for the last
       * RadioButton registered, to props.id would be most likely incorrrect.
       * We convert a possible Number type itemKey back to a Number.
       */
      const convertedValue = !isNaN(Number(value)) ? Number(value) : value;
      onValueChange && onValueChange(convertedValue, true);
    } else {
      onValueChange && onValueChange(id, !checked);
    }
  };

  const SelectionComponent = selectionType === "single" ? RadioButton : Checkbox; // React Hook Form needs a value to maintain selected RadioButton state.

  if (selectionType === "single") {
    others.value = id;
  }

  return _jsx(SelectionComponent, _objectSpread(_objectSpread({}, others), {}, {
    css: selectionCSS,
    onValueChange: handleSelection,
    label: "",
    labelHidden: true
  }));
}

SelectionControl.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Indicates the checked status of the component. */
  checked: PropTypes.bool,

  /** Indicates the disabled status of the component. */
  disabled: PropTypes.bool,

  /** Unique id which represents the data set. */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Function to run on valuechange of selections. */
  onValueChange: PropTypes.func,

  /**
   * Indicates how the row item can be selected. `multi` adds checkboxes, and
   * `single` adds radiobuttons will add those respective control types to the
   * column, whereas the `row` value will cause the entire row to be selectable
   */
  selectionType: PropTypes.oneOf(["multi", "single"])
} : {};
SelectionControl.defaultProps = {
  checked: false,
  disabled: false,
  id: "",
  onChange: null,
  onValueChange: null,
  selectionCSS: {},
  selectionType: "multi"
};
export default SelectionControl;